import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';

import { ClienteNomePipe } from './cliente-nome.pipe';
import { ClienteNomeSecundarioPipe } from './cliente-nome-secundario.pipe';
import { ClienteClassificacaoFaturamentoPositivaPipe } from './cliente-classificacao-faturamento-positiva.pipe';
import { ClienteClassificacaoFaturamentoPositivaColorPipe } from './cliente-classificacao-faturamento-positiva-color.pipe';


@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        ClienteNomePipe,
        ClienteNomeSecundarioPipe,
        ClienteClassificacaoFaturamentoPositivaPipe,
        ClienteClassificacaoFaturamentoPositivaColorPipe
    ],
    exports: [
        SharedModule,

        ClienteNomePipe,
        ClienteNomeSecundarioPipe,
        ClienteClassificacaoFaturamentoPositivaPipe,
        ClienteClassificacaoFaturamentoPositivaColorPipe
    ],
    providers: [
        ClienteNomePipe,
        ClienteNomeSecundarioPipe,
        ClienteClassificacaoFaturamentoPositivaPipe,
        ClienteClassificacaoFaturamentoPositivaColorPipe
    ]
})
export class ClientePipeSharedModule { }
